<template>
  <v-card class="table-card elevation-4">
    <v-data-table :headers="headers" :items="filteredItems" class="custom-table" v-model:page="page"
      v-model:items-per-page="itemsPerPage" no-data-text="No data found">
      <template #top>
        <v-toolbar flat color="transparent">
          <v-toolbar-title class="white--text title">{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
           <!-- <v-tooltip text="Add WareHouse" location="bottom">
                <template #activator="{ props }">
                    <v-icon @click="add()" v-bind="props" class="mr-5" left >mdi-plus</v-icon>
                </template>
            </v-tooltip> -->
          <TextFieldComponent placeholder="Search" v-model="search" class="textFields" />

           <v-tooltip :text="`Add ${title}`" location="bottom">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  class="plus"
                  color="#fff"
                  @click="add"
                >
                  Add
                  <v-icon end>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
        </v-toolbar>
      </template>
      <!-- <template #[`item.contactAccess`]="{ item }">
        {{ item.contactAccess?.flatMap(contact => contact.wareHouse?.map(warehouse => warehouse.warehouse_name) || []).join(', ') || 'No warehouses' }}
      </template> -->

      <template #[`item.edi`]="{ item }">
        <div class="d-flex align-center gap-2">
          <v-chip
            v-if="Array.isArray(item.edi) && item.edi.length > 0"
            variant="flat"
            color="primary"
            size="small"
          >
            {{ item.edi[0] }}
          </v-chip>

          <v-tooltip text="Show all Edi" location="bottom">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                v-if="Array.isArray(item.edi) && item.edi.length > 1"
                variant="text"
                size="small"
                @click="showAllItems(item.edi)"
              >
                ...
              </v-btn>
            </template>
          </v-tooltip>
        </div>
      </template>

      <template #[`item.fedex`]="{ item }">
        {{ item.fedex ? 'Yes' : 'No' }}
      </template>

      <template #[`item.modified_name`]="{ item }">
        <span class="text-crimson">
          {{ item.modified_name }}
        </span>
      </template>

      <template #[`item.modified`]="{ item }">
        <span class="text-crimson">
          {{ item.modified ? moment(item.modified).format("DD-MM-YYYY") : '' }}
        </span>
      </template>

      <template #[`item.actions`]="{ item, index }">
        <v-icon v-if="role < 6" small color="#082FB1" size="20" class="mr-3" @click="onEdit(item, 'edit', index)">mdi-pencil</v-icon>
        <v-icon small color="#082FB1" size="20" class="mr-3" @click="onView(item, 'view')">mdi-eye</v-icon>
        <v-icon v-if="title =='Contact'" color="#082FB1" size="20" @click="warehouseUser(item, 'view')">mdi-account-group</v-icon>
      </template>
    </v-data-table>
    
    <v-dialog v-model="showDialog" max-width="500px">
      <v-card>
        <v-card-title>All Edi Transcations</v-card-title>
        <v-card-text>
          <v-chip
            v-for="(item, index) in dialogItems"
            :key="index"
            variant="flat"
            color="primary"
            size="small"
            class="mr-2 mb-2"
          >
            {{ item }}
          </v-chip>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import moment from "moment";
// import AvatarSelection from "@/menus/AvatarSelection.vue";

export default {
  components: { 
  TextFieldComponent,
  // AvatarSelection 
},
  props: {
    headers: Array,
    dataList: Array,
    title: String,
    role : Number,
    selectedName:String,
  },
  data() {
    return {
      search: "",
      page: 1,
      itemsPerPage: 10,
      showDialog: false,
      dialogItems: [],
      selectedWarehouse:null,
    };
  },
  created() {
    console.log(this.selectedName,"selectedName")
    console.log('this.filteredItems',this.dataList)
  },
  computed: {
    filteredItems() {
      const q = this.search.toLowerCase();
      console.log(q,"qqqqqqqqq")
      console.log(this.dataList,"this.dataList")
      return this.dataList.filter(item =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(q)
        )
      );
    },
  },
  watch: {
    // selectedName(newVal, oldVal) {
    //   console.log("Prop changed:", newVal, oldVal);
    //   this.selectedWarehouse = newVal;
    // },
    search() {
      this.page = 1;
    },
    itemsPerPage() {
      this.page = 1;
    },
  },
  methods: {
    moment,
    getTrimmedText(text) {
      console.log(text,"text@@@@")
      if (Array.isArray(text)) {
        return text.length > 0 ? [text[1]] : [];
      }
      return text && text.length < 2 ? text : text && text.slice(0,2) + ' ...';
    },
    onView(item, viewType) {
      this.$emit("dialogs", item, true, viewType);
    },
    onEdit(item, viewType, index) {
      this.$emit("dialogs", item, true, viewType, index);
    },
    warehouseUser(item,viewType){
      this.$emit("enum",item, true ,viewType)
    },
    add(){
        this.$emit('add',true)
    },
    showAllItems(items) {
      this.dialogItems = items;
      this.showDialog = true;
    }
  },
};
</script>


<style scoped>
.plus{
  background-color: #0d4ba7;
}
.text-crimson {
  color: crimson;
}

.textFields {
  margin-top: 24px;
  margin-right: 14px;
}

.table-card {
  border-radius: 12px;
}

>>>.custom-table th:last-child,

>>>.custom-table td:last-child {

  position: sticky !important;
  right: 0 !important;
  z-index: 10 !important;
  min-width: 120px !important;
  /* display: flex;
    align-items: center;
    gap: 12px; */

}

>>>.custom-table tr:nth-child(even) td:last-child {
  background-color: #f6f6ff !important;
}

>>>.custom-table tr:nth-child(odd) td:last-child {
  background-color: #FFFFFF !important;
}

>>>.custom-table tr:nth-child(even) td:last-child:hover {
  background-color: #c9c9ca !important;
  /* transition: background 0.3s !important;     */
}

>>>.custom-table tr:nth-child(odd) td:last-child:hover {
  background-color: #c9c9ca !important;
  /* transition: background 0.3s !important;     */
}


::v-deep(.custom-table thead th) {
  /* min-width: 250px; */
  /* max-width: 500px; */
  background-color: #e2e2fc !important;
  color: #000000 !important;
  font-weight: 600 !important;
  font-size: 18px;
}

::v-deep(.custom-table tbody tr:nth-child(even)) {
  background-color: #f6f6ff;
}

::v-deep(.custom-table tbody tr:hover) {
  background-color: #c9c9ca;
  transition: background 0.3s;
}

::v-deep(.custom-table tbody td) {
  font-weight: 500;
  font-size: 15px;
  /* min-width: 250px; */
  /* max-width: 500px; */
}

.title {
  font-weight: 500;
}

.custom-table td {
  width: 600px;
}
</style>